var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._g(_vm._b({attrs:{"disabled":_vm.loading}},'b-button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }